import React from "react";
import { string } from "prop-types";
import "./large-text-paragraph.m.css";

export const LargeTextParagraph = ({ children, storyTemplate }) => {
  return (
    <div styleName={`large-text-paragraph ${storyTemplate === "session" ? 'session-template' : ''}`} data-section="overview">
      <div
        styleName={`text-content ${storyTemplate === "session" ? 'session-text' : ''}`}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    </div>
  );
};

LargeTextParagraph.propTypes = {
  children: string.isRequired,
  storyTemplate: string,
};
